import changeIcon from "@/assets/images/changeicon.svg";
import AddAddressModal from "@/app/components/routes/auth_routes/HDCart/AddAddressModal";
import AddressListModal from "@/app/components/routes/auth_routes/HDCart/AddressListModal";
import { ISlotsAddressOption, IHomeServiceAddressProps } from "@/app/components/routes/auth_routes/SlotsScreen/BookingFiltersComponent/interface";

const HomeServiceAddress: React.FC<IHomeServiceAddressProps> = ({
  isHomeServiceFlow,
  isReadonlyHomeServiceFlow,
  selectedAddressText,
  disableSlotsFilter,
  isAddressListModalOpen,
  setIsAddressListModalOpen,
  isAddAddressModalOpen,
  setIsAddAddressModalOpen,
  selectedAddressId,
  setSelectedAddressId,
  slotsAddressList,
  setSlotsAddressList,
  handleAddressSelectionForHomeService,
}) => {
  return (
    <>
      {isHomeServiceFlow &&
        !isReadonlyHomeServiceFlow &&
        (selectedAddressText ? (
          <div className="ml-2 flex-1 min-w-0">
            <div className="max-h-[42px] max-w-[774px] w-full flex items-center justify-between gap-3 rounded-[10px] bg-[#F5F4F4] px-4 py-2">
              <p className="text-[12px] text-[#6c727f] truncate  min-w-0 flex-1">
                <span className="font-medium text-[#6C6C6C] underline">Visit Address:</span>{" "}
                {selectedAddressText}
              </p>

              <button
                type="button"
                disabled={disableSlotsFilter}
                onClick={() => setIsAddressListModalOpen(true)}
                className="flex gap-[6px] whitespace-nowrap rounded-[44px] bg-white px-[8px] py-[4px] text-[12px] font-medium text-[#0068FF] shrink-0"
              >
                <img src={changeIcon} alt="" />
                Change Address
              </button>
            </div>
          </div>
        ) : (
          <div className="ml-2">
            <button
              type="button"
              disabled={disableSlotsFilter}
              onClick={() => setIsAddressListModalOpen(true)}
              className="bg-[#000000] px-[16px] py-[8px] font-semibold rounded-[8px] cursor-pointer text-white text-[14px]"
            >
              Select Address
            </button>
          </div>
        ))}
      {isAddressListModalOpen && (
        <AddressListModal
          isAddressOpen={isAddressListModalOpen}
          onClose={() => setIsAddressListModalOpen(false)}
          closeOnOutsideClick
          payloadData={slotsAddressList}
          openAddAddress={(addressId?: string) => {
            setSelectedAddressId(addressId || null);
            setIsAddressListModalOpen(false);
            setIsAddAddressModalOpen(true);
          }}
          onSelectAddress={handleAddressSelectionForHomeService}
          title="Select Home Service Address"
          isAtHome={isHomeServiceFlow}
        />
      )}
      {isAddAddressModalOpen && (
        <AddAddressModal
          addAddressTitle="Add Home Service Address"
          isAtHome={isHomeServiceFlow}
          closeOnOutsideClick
          onOutsideClose={() => {
            setIsAddAddressModalOpen(false);
            setSelectedAddressId(null);
            setIsAddressListModalOpen(false);
          }}
          addressId={selectedAddressId}
          onClose={() => {
            setIsAddAddressModalOpen(false);
            setSelectedAddressId(null);
            setIsAddressListModalOpen(true);
          }}
          onAddressAdded={(newAddress) => {
            if (!newAddress) {
              setIsAddAddressModalOpen(false);
              setSelectedAddressId(null);
              setIsAddressListModalOpen(true);
              return;
            }
            const normalizedAddress: ISlotsAddressOption = {
              ...newAddress,
              address_id: newAddress?.address_id,
              address_1: newAddress?.address_1 ?? "",
              address_2: newAddress?.address_2 ?? "",
              label: newAddress?.label ?? "Home",
              city: newAddress?.city ?? "",
              state: newAddress?.state ?? "",
              pincode: newAddress?.pincode ?? "",
              latitude: newAddress?.latitude ?? "",
              longitude: newAddress?.longitude ?? "",
              previously_ordered: newAddress?.previously_ordered,
            };
            setSlotsAddressList((prev) => {
              const others = prev.filter((addr) => addr.address_id !== normalizedAddress.address_id);
              return [normalizedAddress, ...others];
            });
            setIsAddAddressModalOpen(false);
            setSelectedAddressId(null);
            setIsAddressListModalOpen(true);
          }}
        />
      )}
    </>
  );
};

export default HomeServiceAddress;
